import instance from "../../services/api";

export const reportRemonts = (params = {}) => {
  return instance(true)
    .post("/partner/report_remonts/", params)
    .then((res = {}) => {
      return res?.data;
    });
};
